/**
 * @generated SignedSource<<09c8cfd9d1ae5c2ad7804bce46f4dc81>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
export type WidgetNoteFontSize = "LARGE" | "MEDIUM" | "SMALL";
export type WidgetNoteFontStyle = "BOLD" | "CURSIVE" | "DEFAULT";
import { FragmentRefs } from "relay-runtime";
export type WidgetNotePageBackgroundSelector_widgetNotePage$data = {
  readonly backgroundColor: string | null;
  readonly fontSize: WidgetNoteFontSize;
  readonly fontStyle: WidgetNoteFontStyle;
  readonly id: string;
  readonly " $fragmentType": "WidgetNotePageBackgroundSelector_widgetNotePage";
};
export type WidgetNotePageBackgroundSelector_widgetNotePage$key = {
  readonly " $data"?: WidgetNotePageBackgroundSelector_widgetNotePage$data;
  readonly " $fragmentSpreads": FragmentRefs<"WidgetNotePageBackgroundSelector_widgetNotePage">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "WidgetNotePageBackgroundSelector_widgetNotePage",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "backgroundColor",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "fontStyle",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "fontSize",
      "storageKey": null
    }
  ],
  "type": "WidgetNotePage",
  "abstractKey": null
};

(node as any).hash = "591a412836830f6f79c2ee6a44be8619";

export default node;
